import {CLOSE_ALL_MODALS, TOGGLE_MODAL} from "../constants/action-types";

export const toggleModal = (modal) => ({
  type: TOGGLE_MODAL,
  payload: {
    modal
  }
});

export const closeAllModals = () => ({
  type: CLOSE_ALL_MODALS
});
